import ajax from "@ep/tools/ajax";
import { getDataFields } from "@ep/components/create/autoform";
import { showElements } from "@ep/tools/showElements";
import msgbox from "@ep/tools/msgbox";
import storage from "@ep/tools/storage";
import session from "@ep/tools/session";

/**
 * Controla renderização da tela de cadastro.
 */
class SignUp {
  /**
   * Inicializa instância da tela de cadastro.
   */
  constructor() {
    // this.textEncoder = new TextEncoder();
    // this.pendingMfa = null;
    // this.deviceId = this.#ensureDeviceId();
  }

  /* ===== API publica ===== */
  /**
   * Renderiza formulário de cadastro para usuários não autenticados.
   * @public
   * @returns {Promise<void>}
   */
  async signup() {
    document.querySelector('main')?.empty?.();
    document.getElementById('header-login-button').enable();
    document.getElementById('header-signup-button').disable();

    const obj = [
      {
        element: 'div', parent: 'main', id: 'af-signup', isGrid: true, content: [
          {
            element: 'autoform',
            type: 'fieldset',
            title: dic.signup.title,
            server: 'accounts',
            module: 'signup',
            isDialog: true,
            callback: (res) => { console.log(res); },
            filter: {
              // conditions: [{ key: 'ut.id', operator: '=', value: '256465f6-d6e3-4da9-87f4-347570611d81', raw: false }],
              // key:'main'
            }
          }
        ]
      }
    ];

    create(obj);
    // let i = 0;
    // if (storage.get('unlockTime')) {
    //   let t = setInterval(() => {
    //     const btn = document.getElementById('bt-login');
    //     if (btn || i === 100) {
    //       if (btn) {
    //         this.#checkLoginLock();
    //       }

    //       i = 0;
    //       clearInterval(t);
    //     }
    //     i++;
    //   }, 10);
    // }
    // if (storage.get('unlockTime')) {
    //   this.#waitForElement('#bt-login')
    //     .then(() => this.#checkLoginLock())
    //     .catch(() => console.warn('Botão não encontrado a tempo.'));
    // }
    // await showElements(['#af-signup']);
  }
}

const signup = new SignUp();
export default () => signup.signup();
